/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgKybcNoBusiness = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="-3 -3 34 33"
    {...props}
  >
    <g filter="url(#kybc-no-business_svg__a)">
      <rect width={22.015} height={15.048} x={3.201} y={8.969} fill="#fff" rx={2.617} />
      <rect
        width={21.905}
        height={14.938}
        x={3.256}
        y={9.024}
        stroke="url(#kybc-no-business_svg__b)"
        strokeOpacity={0.5}
        strokeWidth={0.11}
        rx={2.562}
      />
    </g>
    <g filter="url(#kybc-no-business_svg__c)">
      <rect width={1.942} height={1.963} x={12.913} y={3.735} fill="#fff" rx={0.971} />
      <rect
        width={1.833}
        height={1.853}
        x={12.968}
        y={3.79}
        stroke="url(#kybc-no-business_svg__d)"
        strokeOpacity={0.5}
        strokeWidth={0.11}
        rx={0.916}
      />
    </g>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={1.309}
      d="m5.791 9.625 6.271-6.084a2.617 2.617 0 0 1 3.645 0l6.271 6.084"
    />
    <path
      fill="#74DBC9"
      d="M8.843 13.527a.498.498 0 0 0-.187-.141.604.604 0 0 0-.252-.05.649.649 0 0 0-.268.056.65.65 0 0 0-.213.157.744.744 0 0 0-.14.236.879.879 0 0 0-.05.298c0 .109.017.209.05.3.035.09.081.169.14.236a.611.611 0 0 0 .465.21.553.553 0 0 0 .478-.249l.425.317a.886.886 0 0 1-.373.304c-.15.066-.305.099-.465.099-.18 0-.348-.029-.5-.085a1.16 1.16 0 0 1-.396-.242 1.142 1.142 0 0 1-.262-.387 1.329 1.329 0 0 1-.091-.503c0-.186.03-.354.091-.504a1.134 1.134 0 0 1 .658-.628c.152-.057.32-.085.5-.085.066 0 .133.006.203.02a.986.986 0 0 1 .409.16c.063.043.12.097.17.16l-.392.32Zm.6.556c0-.186.03-.354.092-.504a1.134 1.134 0 0 1 .657-.628c.153-.057.32-.085.5-.085.182 0 .349.028.501.085.153.056.285.138.396.245.111.105.197.232.258.383.064.15.095.318.095.504 0 .185-.031.353-.095.503-.06.15-.147.28-.258.386a1.16 1.16 0 0 1-.396.243c-.152.056-.32.085-.5.085-.181 0-.348-.029-.5-.085a1.16 1.16 0 0 1-.397-.242 1.142 1.142 0 0 1-.261-.387 1.329 1.329 0 0 1-.092-.503Zm.53 0a.73.73 0 0 0 .196.536.68.68 0 0 0 .226.154.77.77 0 0 0 .298.056.746.746 0 0 0 .294-.056.673.673 0 0 0 .23-.154.686.686 0 0 0 .143-.235.839.839 0 0 0 .053-.301.83.83 0 0 0-.053-.298.648.648 0 0 0-.373-.393.746.746 0 0 0-.294-.055.77.77 0 0 0-.298.055.687.687 0 0 0-.373.393.88.88 0 0 0-.049.298Zm2.316-1.158h.772l.534 1.511h.006l.537-1.511h.768v2.316h-.51v-1.777h-.007l-.608 1.777h-.39l-.585-1.777H12.8v1.777h-.51v-2.316Zm3.083 0h.51v2.316h-.51v-2.316Zm.974 0h.694l.985 1.61h.006v-1.61h.51v2.316h-.667l-1.01-1.649h-.007v1.649h-.51v-2.316Zm4.765 2.152c-.15.079-.308.135-.471.17-.164.035-.33.053-.5.053-.182 0-.349-.029-.501-.085a1.16 1.16 0 0 1-.396-.242 1.143 1.143 0 0 1-.262-.387 1.33 1.33 0 0 1-.091-.503c0-.186.03-.354.091-.504a1.135 1.135 0 0 1 .658-.628c.152-.057.32-.085.5-.085.186 0 .356.023.51.068.158.044.295.12.413.23l-.36.392a.717.717 0 0 0-.236-.164.839.839 0 0 0-.327-.055.77.77 0 0 0-.297.055.685.685 0 0 0-.373.393.88.88 0 0 0-.05.298c0 .109.017.209.05.3a.68.68 0 0 0 .373.39.77.77 0 0 0 .297.056c.112 0 .208-.013.288-.037.081-.026.145-.052.193-.078v-.376h-.415v-.471h.906v1.21Zm-10.517 2.414a.352.352 0 0 0-.17-.115.53.53 0 0 0-.314-.026.405.405 0 0 0-.111.042.229.229 0 0 0-.085.072.186.186 0 0 0-.033.112c0 .07.026.123.079.16a.748.748 0 0 0 .196.095c.08.026.167.052.258.078.092.027.177.064.255.111.081.049.148.113.2.194.052.08.079.188.079.323a.744.744 0 0 1-.072.337.675.675 0 0 1-.197.24.808.808 0 0 1-.284.14c-.107.03-.22.046-.34.046-.151 0-.29-.023-.42-.07a1.05 1.05 0 0 1-.36-.221l.364-.4a.549.549 0 0 0 .57.206.416.416 0 0 0 .114-.045.227.227 0 0 0 .081-.076.18.18 0 0 0 .033-.107.19.19 0 0 0-.082-.164.689.689 0 0 0-.2-.105 6.238 6.238 0 0 0-.26-.085 1.181 1.181 0 0 1-.263-.114.648.648 0 0 1-.202-.19.552.552 0 0 1-.079-.31c0-.125.024-.234.072-.328a.736.736 0 0 1 .196-.236.846.846 0 0 1 .285-.14c.107-.033.217-.05.33-.05.131 0 .258.02.38.056.122.037.232.1.33.187l-.35.383Zm.61.592c0-.186.03-.354.091-.504a1.133 1.133 0 0 1 .658-.628c.152-.057.319-.085.5-.085s.348.028.5.085c.153.056.285.138.396.245.112.105.198.232.259.383.063.15.095.318.095.504 0 .185-.032.353-.095.504-.061.15-.147.279-.259.386a1.16 1.16 0 0 1-.396.242c-.152.056-.319.085-.5.085s-.348-.029-.5-.085a1.16 1.16 0 0 1-.396-.242 1.142 1.142 0 0 1-.262-.386 1.328 1.328 0 0 1-.092-.504Zm.53 0c0 .109.016.209.048.3a.681.681 0 0 0 .373.39.77.77 0 0 0 .298.055c.11 0 .207-.018.294-.055a.672.672 0 0 0 .23-.154.685.685 0 0 0 .143-.235.839.839 0 0 0 .053-.301.83.83 0 0 0-.053-.298.65.65 0 0 0-.373-.393.745.745 0 0 0-.294-.055.77.77 0 0 0-.298.055.687.687 0 0 0-.373.393.88.88 0 0 0-.049.298Zm2.191 0c0-.186.03-.354.092-.504.063-.15.15-.278.261-.383.112-.107.244-.189.396-.245.153-.057.32-.085.5-.085.182 0 .349.028.501.085.153.056.285.138.396.245.111.105.198.232.259.383.063.15.095.318.095.504 0 .185-.032.353-.095.504-.061.15-.147.279-.259.386a1.16 1.16 0 0 1-.396.242c-.152.056-.32.085-.5.085-.181 0-.348-.029-.5-.085a1.16 1.16 0 0 1-.397-.242 1.143 1.143 0 0 1-.261-.386 1.33 1.33 0 0 1-.092-.504Zm.53 0c0 .109.017.209.05.3.034.09.083.169.146.236a.68.68 0 0 0 .226.154.77.77 0 0 0 .298.055.745.745 0 0 0 .294-.055.673.673 0 0 0 .23-.154.686.686 0 0 0 .143-.235.839.839 0 0 0 .053-.301.83.83 0 0 0-.053-.298.648.648 0 0 0-.373-.393.745.745 0 0 0-.294-.055.77.77 0 0 0-.298.055.684.684 0 0 0-.373.393.877.877 0 0 0-.049.298Zm2.316-1.158h.694l.985 1.61h.006v-1.61h.51v2.316H18.3l-1.01-1.649h-.007v1.649h-.51v-2.316Z"
    />
    <defs>
      <linearGradient
        id="kybc-no-business_svg__b"
        x1={5.573}
        x2={24.266}
        y1={14.017}
        y2={14.168}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="kybc-no-business_svg__d"
        x1={13.122}
        x2={14.772}
        y1={4.394}
        y2={4.403}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <filter
        id="kybc-no-business_svg__a"
        width={38.504}
        height={31.538}
        x={-5.044}
        y={0.724}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={4.122} />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4313_6459" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={2.748} dy={2.748} />
        <feGaussianBlur stdDeviation={2.748} />
        <feColorMatrix values="0 0 0 0 0.102795 0 0 0 0 0.795833 0 0 0 0 0.54634 0 0 0 0.5 0" />
        <feBlend in2="effect1_backgroundBlur_4313_6459" result="effect2_dropShadow_4313_6459" />
        <feBlend in="SourceGraphic" in2="effect2_dropShadow_4313_6459" result="shape" />
      </filter>
      <filter
        id="kybc-no-business_svg__c"
        width={18.432}
        height={18.452}
        x={4.668}
        y={-4.509}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={4.122} />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4313_6459" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={2.748} dy={2.748} />
        <feGaussianBlur stdDeviation={2.748} />
        <feColorMatrix values="0 0 0 0 0.102795 0 0 0 0 0.795833 0 0 0 0 0.54634 0 0 0 0.5 0" />
        <feBlend in2="effect1_backgroundBlur_4313_6459" result="effect2_dropShadow_4313_6459" />
        <feBlend in="SourceGraphic" in2="effect2_dropShadow_4313_6459" result="shape" />
      </filter>
    </defs>
  </svg>
)
